'use client';
import { useGSAP } from '@gsap/react';
import clsx from 'clsx';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import initAnimation from './animations/label-to-training-animation';
import { useLocale } from '@/components/providers/context/locale-context';
import {
    buildStaticAssetPath,
    getStaticAssetUrl,
} from '@/app/lib/utils/static-asset-url';
function LabelToTraining() {
    const { t } = useTranslation('safeguarding-privacy');
    const locale = useLocale();

    const rootRef = useRef<HTMLDivElement>(null);
    const containerRef = useRef<HTMLDivElement>(null);
    const mobileBackgroundImageUrl = getStaticAssetUrl(
        buildStaticAssetPath('home', 'mobile-bg-label2traning.webp'),
    );
    const desktopBackgroundImageUrl = getStaticAssetUrl(
        buildStaticAssetPath('home', 'bg-label2traning.webp'),
    );

    useGSAP(
        () => {
            initAnimation(rootRef.current!, containerRef.current!);
        },
        { scope: rootRef },
    );

    return (
        <div
            id="label2training"
            ref={rootRef}
            className="relative flex h-[var(--simulaix-vh,100svh)] w-full flex-col items-center justify-center gap-[12px] overflow-hidden"
        >
            <div
                className="pointer-events-none absolute inset-0 bg-cover bg-center bg-no-repeat sm:hidden"
                style={{
                    backgroundImage: `url(${mobileBackgroundImageUrl})`,
                }}
            />
            <div
                className="pointer-events-none absolute inset-0 hidden bg-cover bg-center bg-no-repeat sm:block"
                style={{
                    backgroundImage: `url(${desktopBackgroundImageUrl})`,
                }}
            />
            <h2
                ref={containerRef}
                className="relative z-10 flex w-full flex-col items-center"
            >
                <div
                    className={clsx(
                        'j-t1 label2trainingLine px-[70px] text-center text-[#FFFFFF]',
                    )}
                >
                    {t('tranning.firstLine')}
                </div>
                <div className="hidden">
                    {locale === 'en' ? '\u00A0' : '：'}
                </div>
                <div
                    className={clsx(
                        'j-h1 label2trainingLine flex flex-col items-center justify-center text-center text-[#FFFFFF]',
                    )}
                >
                    <div>{t('tranning.secondLine')}</div>
                </div>
                <div
                    className={clsx(
                        'j-t1 label2trainingLine px-[70px] text-center text-[#FFFFFF]',
                    )}
                >
                    <div>{t('tranning.thirdLine')}</div>
                </div>
            </h2>
        </div>
    );
}

export default LabelToTraining;
